import React from 'react';
import { Calendar, User, ArrowRight } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { Card, CardContent } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { Button } from '../components/ui/button';

const Blog = () => {
  const { language } = useLanguage();

  const posts = [
    {
      title: language === 'es' ? 'Cómo la IA está transformando las ventas' : 'How AI is transforming sales',
      excerpt: language === 'es'
        ? 'Descubre cómo los agentes de IA están revolucionando el proceso de ventas y mejorando las tasas de conversión.'
        : 'Discover how AI agents are revolutionizing the sales process and improving conversion rates.',
      category: language === 'es' ? 'Ventas' : 'Sales',
      date: '15 Enero 2025',
      author: 'GERVIS Team',
      image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&h=600&fit=crop'
    },
    {
      title: language === 'es' ? 'Speed to Lead: La clave del éxito' : 'Speed to Lead: The key to success',
      excerpt: language === 'es'
        ? 'Por qué contactar a tus leads en el primer minuto puede aumentar tus conversiones hasta 3x.'
        : 'Why contacting your leads in the first minute can increase your conversions up to 3x.',
      category: language === 'es' ? 'Estrategia' : 'Strategy',
      date: '10 Enero 2025',
      author: 'GERVIS Team',
      image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&h=600&fit=crop'
    },
    {
      title: language === 'es' ? 'Automatización inteligente de seguimiento' : 'Intelligent follow-up automation',
      excerpt: language === 'es'
        ? 'Cómo automatizar el seguimiento de leads sin perder el toque personal.'
        : 'How to automate lead follow-up without losing the personal touch.',
      category: language === 'es' ? 'Automatización' : 'Automation',
      date: '5 Enero 2025',
      author: 'GERVIS Team',
      image: 'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=800&h=600&fit=crop'
    }
  ];

  return (
    <div className="bg-black text-white min-h-screen">
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-br from-green-900/20 via-black to-emerald-900/20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-6xl font-bold mb-6">
              {language === 'es' ? 'Blog de' : 'Blog'}{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-emerald-400">
                GERVIS
              </span>
            </h1>
            <p className="text-xl text-gray-200">
              {language === 'es'
                ? 'Insights, consejos y tendencias sobre IA y automatización'
                : 'Insights, tips and trends about AI and automation'}
            </p>
          </div>
        </div>
      </section>

      {/* Posts Section */}
      <section className="py-20 bg-gradient-to-b from-black to-gray-900">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
            {posts.map((post, index) => (
              <Card key={index} className="bg-gradient-to-br from-gray-900 to-black border-green-900/30 hover:border-green-600/50 transition-all duration-300 group overflow-hidden">
                <div className="relative h-48 overflow-hidden">
                  <img 
                    src={post.image} 
                    alt={post.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                  />
                  <div className="absolute top-4 left-4">
                    <Badge className="bg-green-600 text-white border-none">
                      {post.category}
                    </Badge>
                  </div>
                </div>
                <CardContent className="p-6">
                  <div className="flex items-center space-x-4 text-sm text-gray-400 mb-4">
                    <div className="flex items-center space-x-1">
                      <Calendar className="w-4 h-4" />
                      <span>{post.date}</span>
                    </div>
                    <div className="flex items-center space-x-1">
                      <User className="w-4 h-4" />
                      <span>{post.author}</span>
                    </div>
                  </div>
                  <h3 className="text-xl font-bold mb-3 group-hover:text-green-400 transition-colors">
                    {post.title}
                  </h3>
                  <p className="text-gray-200 mb-4">{post.excerpt}</p>
                  <Button variant="link" className="text-green-400 hover:text-green-300 p-0">
                    {language === 'es' ? 'Leer más' : 'Read more'}
                    <ArrowRight className="w-4 h-4 ml-2" />
                  </Button>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Blog;